import React, {useCallback, useEffect, useMemo} from 'react'
import {useForm} from 'react-hook-form'
import {ForkygramUploadData, UserInfoBase} from 'types'
import {useDidMount} from 'utils'
import {TemplateUploadSearchCollaborator} from '../../../../../template'
import {ForkygramTemplateUploadContent} from '../Content'
import {ForkygramTemplateUploadFormProps} from './ForkygramTemplateUploadFormProps'

export default function ForkygramTemplateUploadForm({
  src,
  caption = '',
  tag = {id: '', name: '', tree_id: '', alias: ''},
  height = 0,
  size = 0,
  width = 0,
  contentType,
  editContent,
  thumbnail,
  stateFormError,
  onFormUpdate,
  stateSearchCollaborator,
  stateCollaborator,
  hasCustomHeader,
}: ForkygramTemplateUploadFormProps) {
  const [searchCollaborator, setSearchCollaborator] = stateSearchCollaborator
  const [collaborator, setCollaborator] = stateCollaborator
  const form = useForm<ForkygramUploadData>({
    defaultValues: {
      caption,
      tag,
      height,
      size,
      width,
      collaborator_member_ids: collaborator ? [collaborator.id] : undefined,
    },
  })
  const {register} = form

  const handleAddCollaborator = useCallback(
    (member: UserInfoBase) => {
      setSearchCollaborator(false)
      setCollaborator(member)
      form.setValue('collaborator_member_ids', [member.id])
    },
    [form, setCollaborator, setSearchCollaborator],
  )

  const handleRenderSearchCollaborator = useMemo(
    () =>
      searchCollaborator && (
        <TemplateUploadSearchCollaborator
          onSelected={handleAddCollaborator}
          hasCustomHeader={hasCustomHeader}
        />
      ),
    [handleAddCollaborator, hasCustomHeader, searchCollaborator],
  )

  const handleRenderContent = useMemo(
    () =>
      src ? (
        <ForkygramTemplateUploadContent
          contentType={contentType}
          form={form}
          src={src}
          editContent={editContent}
          thumbnail={thumbnail}
          stateFormError={stateFormError}
          onAddCollaborator={() => setSearchCollaborator(true)}
          stateCollaborator={stateCollaborator}
        />
      ) : null,
    [
      contentType,
      editContent,
      form,
      setSearchCollaborator,
      src,
      stateCollaborator,
      stateFormError,
      thumbnail,
    ],
  )

  useDidMount(() => {
    register('extension')
    register('height')
    register('width')
    register('size')
    register('mime')
    register('file')
    register('caption')
    register('tag')
    register('duration')
    register('collaborator_member_ids')
    register('thumbnail')
    register('thumbnail_link')
  })

  useEffect(() => {
    onFormUpdate && onFormUpdate(form)
  }, [form, onFormUpdate])

  return (
    <>
      {searchCollaborator
        ? handleRenderSearchCollaborator
        : handleRenderContent}
    </>
  )
}
